/**
 * exportConfig.ts — build-time constants for the PDF export (T-258, BEAD-0041).
 *
 * DATA_VINTAGE is the human-readable vintage stamped on every export ("data as of …"). The app
 * has no per-tract vintage field today, so this is a single build-time constant: bump it whenever
 * the Atlas data is refreshed so the artifact never misstates how current its numbers are. This is
 * exactly the `{DATA_VINTAGE}` placeholder the proposal's footer anticipated.
 */
export const DATA_VINTAGE = 'July 2026'

/** Copyright year for the footer. A runtime util (not the pure model), so reading the clock is fine. */
export function currentYear(): number {
  return new Date().getFullYear()
}
